import { motion } from "framer-motion";
import { useState } from "react";
import Bali from "../images/bali.jpg";
import Paris from "../images/paris.jpg";
import Maldives from "../images/maldives.jpg";
import Dubai from "../images/dubai.jpg";
import Rome from "../images/rome.jpg";
import Baku from "../images/baku.jpg";
import SectionHeading from "./ui/SectionHeading";

const Gallery = () => {
  const images = [
    { src: Bali, title: "Bali, Indonesia", desc: "Tropical paradise with serene beaches" },
    { src: Paris, title: "Paris, France", desc: "The city of lights and love" },
    { src: Maldives, title: "Maldives", desc: "Crystal-clear waters and luxury resorts" },
    { src: Dubai, title: "Dubai, UAE", desc: "Modern marvels and desert adventures" },
    { src: Rome, title: "Rome, Italy", desc: "Historic charm with timeless beauty" },
    { src: Baku, title: "Baku, Azerbaijan", desc: "Where tradition meets modernity" },
  ];
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section id="gallery" className="section-pad overflow-hidden bg-[#dfecd5]">
      <SectionHeading eyebrow="Memories" title="Gallery" subtitle="A glimpse of the journeys and destinations we make possible." />
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3">
        {images.map((img, idx) => (
          <motion.div
            key={img.title}
            className="group relative overflow-hidden rounded-2xl shadow-soft"
            style={{ transformPerspective: 1000 }}
            initial={{ opacity: 0, y: 50, rotateX: 10 }}
            whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.65, delay: idx * 0.08 }}
            onClick={() => setActiveIndex(activeIndex === idx ? null : idx)}
          >
            <img
              src={img.src}
              alt={img.title}
              className="h-64 w-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div
              className={`absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-t from-brand-dark/90 via-brand-dark/40 to-transparent p-4 text-center text-white transition-opacity duration-300 ${
                activeIndex === idx ? "opacity-100" : "opacity-0 group-hover:opacity-100"
              }`}
            >
              <h3 className="mb-2 text-lg font-bold text-brand-gold">{img.title}</h3>
              <p className="text-sm text-white/85">{img.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
